export const ADMIN_EMAILS = [
    'luk.gaw2@gmail.com',
    'suryanshsinghstudy@gmail.com',
    'radieu@gmail.com',
    'sv.sunnysharma@gmail.com',
    'f.giera@microsystem.com.pl'
];
